import sound from './woosh.wav';export default sound;